import { render, staticRenderFns } from "./IconSvgPhone.vue?vue&type=template&id=ccc153da&scoped=true&"
import script from "./IconSvgPhone.vue?vue&type=script&lang=js&"
export * from "./IconSvgPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc153da",
  null
  
)

export default component.exports